import React, { useState, useEffect } from 'react';

function AttendanceForm({ zoneId, zoneName, date, shift, onClose }) {
  const [employees, setEmployees] = useState([]);
  const [productionPlan, setProductionPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const STATUS_OPTIONS = [
    { value: 'work', label: '✅ На работе', short: 'На работе', color: 'green' },
    { value: 'sick', label: '🤒 Болеет', short: 'Болеет', color: 'orange' },
    { value: 'absent', label: '❌ Не вышел', short: 'Не вышел', color: 'red' },
    { value: 'dayoff', label: '🏖 Выходной', short: 'Выходной', color: 'blue' },
    { value: 'vacation', label: '🌴 Отпуск', short: 'Отпуск', color: 'purple' }
  ];

  useEffect(() => {
    setLoading(true);
    fetch(
      `/api/attendance?date=${date}&shift=${shift}&zone_id=${zoneId}`
    )
    
      .then((r) => r.json())
      .then((data) => {
        setEmployees(data.employees || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [zoneId, date, shift]);
  // Загрузка плана на дату
useEffect(() => {
  fetch(`/api/production?date=${date}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  })
    .then((r) => r.json())
    .then((data) => setProductionPlan(data))
    .catch(() => setProductionPlan(null));
}, [date]);

  const handleStatusChange = (employeeId, newStatus) => {
    setEmployees((prev) =>
      prev.map((e) =>
        e.employee_id === employeeId ? { ...e, status: newStatus } : e
      )
    );
    setSaved(false);
  };

  const handleCommentChange = (employeeId, comment) => {
    setEmployees((prev) =>
      prev.map((e) =>
        e.employee_id === employeeId ? { ...e, comment } : e
      )
    );
    setSaved(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const records = employees.map((e) => ({
        employee_id: e.employee_id,
        status: e.status,
        comment: e.comment
      }));

      const res = await fetch('/api/attendance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, shift, records })
      });

      if (!res.ok) throw new Error('Ошибка сохранения');
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      alert('Ошибка: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handlePrint = () => {
  window.print();
};

  // Сводка по статусам
  const summary = {
    work: employees.filter((e) => e.status === 'work').length,
    sick: employees.filter((e) => e.status === 'sick').length,
    absent: employees.filter((e) => e.status === 'absent').length,
    dayoff: employees.filter((e) => e.status === 'dayoff').length,
    vacation: employees.filter((e) => e.status === 'vacation').length
  };

  const formatDate = (d) => {
    if (!d) return '—';
    const dateOnly = d.toString().split('T')[0];
    const [year, month, day] = dateOnly.split('-');
    return `${day}.${month}.${year}`;
  };

  const getStatusLabel = (status) => {
    const opt = STATUS_OPTIONS.find((o) => o.value === status);
    return opt ? opt.short : status;
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-body" style={{ padding: '40px', textAlign: 'center' }}>
            ⏳ Загрузка...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay attendance-modal-overlay" onClick={onClose}>
      <div className="modal modal-large attendance-modal" onClick={(e) => e.stopPropagation()}>
        {/* ЭКРАННАЯ ШАПКА */}
        <div className="modal-header no-print">
  <h2>
    📋 Отчёт за {formatDate(date)} — {zoneName} (
    {shift === 'day' ? '☀️ День' : '🌙 Ночь'})
    {productionPlan && productionPlan.plan_amount !== null && (
      <div className="plan-in-modal">
        📦 План на день: <b>{new Intl.NumberFormat('ru-RU').format(productionPlan.plan_amount)}</b> ланчбоксов
      </div>
    )}
  </h2>
  <button className="modal-close" onClick={onClose}>×</button>
</div>

        {/* ПЕЧАТНАЯ ШАПКА */}
        <div className="print-header-attendance">
  <h1>Отчёт за {formatDate(date)} — {zoneName} ({shift === 'day' ? 'День' : 'Ночь'})</h1>
  {productionPlan && productionPlan.plan_amount !== null && (
    <div className="print-plan">
      План на день: {new Intl.NumberFormat('ru-RU').format(productionPlan.plan_amount)} ланчбоксов
    </div>
  )}
  <div className="print-meta-attendance">
    <span>Дата печати: {new Date().toLocaleDateString('ru-RU')}</span>
    <span>Всего сотрудников: {employees.length}</span>
  </div>
</div>

        <div className="modal-body">
          {employees.length === 0 ? (
            <div className="empty" style={{ padding: '40px' }}>
              В этой зоне нет сотрудников в эту смену
            </div>
          ) : (
            <>
              {/* ЭКРАННАЯ ТАБЛИЦА — с селектами */}
              <table className="table attendance-table no-print">
                <thead>
                  <tr>
                    <th style={{ width: '80px' }}>Табель</th>
                    <th>ФИО</th>
                    <th style={{ width: '180px' }}>Должность</th>
                    <th style={{ width: '200px' }}>Статус</th>
                    <th style={{ width: '200px' }}>Комментарий</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((emp) => (
                    <tr key={emp.employee_id}>
                      <td className="col-tab-value">{emp.tab_number || '—'}</td>
                      <td className="emp-name">
                        {emp.gender === 'м' ? '👨' : '👩'} {emp.full_name}
                      </td>
                      <td>
                        <span className="role-label">{emp.role_name}</span>
                      </td>
                      <td>
                        <select
                          className={`attendance-select status-${emp.status}`}
                          value={emp.status}
                          onChange={(e) =>
                            handleStatusChange(emp.employee_id, e.target.value)
                          }
                        >
                          {STATUS_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="attendance-comment"
                          value={emp.comment || ''}
                          onChange={(e) =>
                            handleCommentChange(emp.employee_id, e.target.value)
                          }
                          placeholder="—"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* ПЕЧАТНАЯ ТАБЛИЦА — чистая, без эмодзи */}
              <table className="table print-table-attendance">
                <thead>
                  <tr>
                    <th style={{ width: '80px' }}>Табель</th>
                    <th>ФИО</th>
                    <th style={{ width: '200px' }}>Должность</th>
                    <th style={{ width: '130px' }}>Статус</th>
              
                  </tr>
                </thead>
                <tbody>
                  {employees.map((emp) => (
                    <tr key={emp.employee_id}>
                      <td>{emp.tab_number || '—'}</td>
                      <td>{emp.full_name}</td>
                      <td>{emp.role_name}</td>
                      <td>{getStatusLabel(emp.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* ПЕЧАТНАЯ СВОДКА */}
              <div className="print-summary-attendance">
                <b>Итого:</b> На работе: {summary.work} | Болеет: {summary.sick} | Не вышел: {summary.absent} | Выходной: {summary.dayoff} | Отпуск: {summary.vacation}
              </div>
            </>
          )}
        </div>

        <div className="modal-footer no-print">
          <div className="attendance-summary">
            <span className="sum-item sum-work">✅ {summary.work}</span>
            <span className="sum-item sum-sick">🤒 {summary.sick}</span>
            <span className="sum-item sum-absent">❌ {summary.absent}</span>
            <span className="sum-item sum-dayoff">🏖 {summary.dayoff}</span>
            <span className="sum-item sum-vacation">🌴 {summary.vacation}</span>
          </div>
          <div className="modal-footer-right">
            {saved && <span className="saved-badge">✅ Сохранено</span>}
            <button className="btn-cancel" onClick={onClose}>
              Закрыть
            </button>
            <button
              className="btn-print-attendance"
              onClick={handlePrint}
              title="Печать отчёта"
            >
              🖨 Печать
            </button>
            <button
              className="btn-save"
              onClick={handleSave}
              disabled={saving || employees.length === 0}
            >
              {saving ? '⏳ Сохранение...' : '💾 Сохранить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceForm;